export const aboutData = {
    title: "Who I Am",
    description1: "Hey there, I'm Sunidhi – a creative soul navigating the web design and development realm from Bengaluru, India.",
    description2: "By day, I spearhead projects as a backend developer. By night, I dive into freelance gigs, crafting my own innovative products. Amidst this whirlwind, I indulge in penning articles, weaving poetry, and delving into the fascinating worlds of machine learning and AI. I'm a perpetual learner, endlessly curious, always seeking out new frontiers.",
    image: 2
}
